<template>
  <div class="page">
    <Button @click="onShowDomainList" shape="circle"
      >从我的域名列表选择域名</Button
    >
    <!-- 过户域名 -->
    <Form label-position="top" style="margin-top: 40px">
      <FormItem class="cc-form-item" :label="'过户域名' + dnNumber" required>
        <Input
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 500 }"
          v-model="form.domain"
          @on-keyup="getDNNumber"
          @on-blur="getAvailableDN"
          placeholder="每行一个域名，最多500个"
          style="width: 500px"
        ></Input>
      </FormItem>
      <FormItem class="cc-form-item" label="过户域名" required>
        <div class="cond-row">
          <div class="item" style="margin-right: 100px">
            <div style="margin-right: 10px">选择默认模板：</div>
            <Button type="primary" @click="showCheckedTemplate">{{
              !templateInfo.templateId ? "选择模板" : templateInfo.templateName
            }}</Button>
          </div>
        </div>
      </FormItem>
      <FormItem class="cc-form-item" label="60天内禁止转移注册商锁定" required>
        <div class="cond-row" style="line-height: 32px">
          <RadioGroup v-model="form.isLock">
            <Radio :label="0"> 不设置</Radio>
            <Radio :label="1"> 设置</Radio>
          </RadioGroup>
          <div style="color: #2d8cf0">
            (域名若设置60天内禁止转移注册商锁定，模板过户成功后60天你才可以转出)
          </div>
        </div>
      </FormItem>
      <Button
        class="btn-height45"
        :loading="loading"
        type="primary"
        @click="onConfirm"
        >确认提交</Button
      >
    </Form>
    <!-- 选择域名 -->
    <domainListModal
      :show.sync="domainListModalVisibility"
      :checkedDomain="checkedDomain"
      @onChecked="onChecked"
    ></domainListModal>
    <!-- 选择模板 -->
    <templateListModal
      :show.sync="templateListModalVisibility"
      @onChecked="checkedTemplate"
    ></templateListModal>
    <!-- 转入结果 -->
    <transferListModal
      :show.sync="transferistModalVisibility"
      :data="resultList"
    ></transferListModal>
  </div>
</template>
<script>
import domainListModal from "components/domain/domainListModal.vue";
import templateListModal from "components/template/templateListModal.vue";
import transferListModal from "components/template/transferListModal.vue";
import { debounce, trimStr } from "utils/index";
import { templatesTransfer } from "api/domain.js";
import { mapMutations, mapState } from "vuex";

export default {
  name: "templateTransfer",
  components: {
    domainListModal,
    templateListModal,
    transferListModal,
  },
  data() {
    return {
      loading: false,
      domainListModalVisibility: false,
      templateListModalVisibility: false,
      templateInfo: {},
      checkedDomain: [],
      form: {
        domain: "",
        isLock: 0,
      },
      dnNumber: 0,
      transferistModalVisibility: false,
      resultList: [],
    };
  },
  computed: {
    ...mapState(["routeParamsList"]),
  },
  created() {
    if (this.routeParamsList.length > 0) {
      this.checkedDomain = this.routeParamsList;
      const domainStr = this.routeParamsList.join("\n");
      this.form.domain = domainStr;
      this.dnNumber = this.routeParamsList.length;
    }
  },
  beforeDestroy() {
    // 传递参数
    this.MTU_ROUTE_PARAMS_LIST([]);
  },
  methods: {
    ...mapMutations(["MTU_ROUTE_PARAMS_LIST"]),
    onShowDomainList() {
      this.domainListModalVisibility = true;
    },
    // 选中域名
    onChecked(val) {
      this.checkedDomain = val;
      const domainStr = val.join("\n");
      this.form.domain = domainStr;
      this.dnNumber = val.length;
    },
    // 打开选择模板
    showCheckedTemplate() {
      this.templateListModalVisibility = true;
    },
    // 选中模板回调
    checkedTemplate(val) {
      this.templateInfo = val;
      this.templateListModalVisibility = false;
    },
    // 函数防抖获取输入框中的域名
    getDNNumber: debounce(function () {
      const temp = this.form.domain.split("\n");
      this.dnNumber = temp.filter((item) => {
        return !item.match(/^[ ]*$/);
      }).length;
    }, 200),
    // 筛选出有用域名
    getAvailableDN() {
      const temp = this.form.domain.split("\n").filter((item) => {
        return !item.match(/^[ ]*$/);
      });
      const dnList = temp.map((item) => trimStr(item));
      this.dnSet = new Set(dnList);
      this.checkedDomain = [...this.dnSet];
      this.form.domain = [...this.dnSet].join("\n");
      this.dnNumber = this.dnSet.size;
    },
    async onConfirm() {
      try {
        let domains = this.form.domain.split("\n").filter((item) => {
          return !item.match(/^[ ]*$/);
        });
        if (domains.length === 0) {
          this.$Message.warning("请输入域名！");
          return false;
        }
        if (!this.templateInfo.templateId) {
          this.$Message.warning("请选择模板！");
          return false;
        }
        this.loading = true;
        let params = {
          domainNames: domains,
          isLock: this.form.isLock,
          templateId: this.templateInfo.templateId,
        };
        const { code, data } = await templatesTransfer(params);
        if (code === 200) {
          if (data.length === 0) {
            this.$Message.success("操作成功!");
            this.form.domain = "";
            this.dnNumber = 0;
            this.templateInfo = {};
            this.checkedDomain = [];
          } else {
            this.resultList = data;
            this.transferistModalVisibility = true;
          }
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  background-color: #fff;
  padding: 40px 60px 80px;
}
/deep/.cc-form-item {
  .ivu-form-item-label {
    padding-bottom: 20px;
  }
}
/deep/.height60 {
  .ivu-input {
    height: 60px;
    line-height: 60px;
  }
  .ivu-input-icon {
    line-height: 60px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 60px;
  }
  .ivu-select-input {
    height: 60px;
  }
  .ivu-select-selected-value {
    height: 60px;
    line-height: 60px;
  }
  .ivu-select-placeholder {
    height: 60px;
    line-height: 60px;
  }
}
.cond-row {
  display: flex;
  flex-wrap: wrap;
  line-height: 60px;
  .item {
    display: flex;
    align-items: center;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
